module.exports = __webpack_public_path__ + "img/australia-diabetes-mellitus-male.284094d6.png";